import "./styles.css";

import PropertyCarousel, { PropertyType } from "../components/PropertyCarousel";
import { useEffect, useState } from "react";

import Filter from "../components/Filter";
import { Grid } from "@mui/material";
import HelpWithPanel from "../components/HelpWithPanel";
import LandingPageSection from "../components/LandingPageSection";
import PropertyCard from "../components/PropertyCard";
import axios from "axios";
import { API_URL } from "../config/api";

export const MainPage = () => {
  const [listings, setListings] = useState([]);
  const [shouldUpdate, setShouldUpdate] = useState(true);

  useEffect(() => {
    if (shouldUpdate) {
      axios.get(`${API_URL}/listings`).then((res) => {
        setListings(res.data);
      });
      setShouldUpdate(false);
    }
  }, [shouldUpdate]);

  const [filteredData, setFilteredData] = useState(listings);

  useEffect(() => {
    setFilteredData(listings);
  }, [listings]);

  // const handleFilter = (filters: any) => {
  //     let filtered = listings;

  //     if (filters.title) {
  //         filtered = filtered.filter((item) =>
  //             // @ts-ignore
  //             item.title.toLowerCase().includes(filters.title.toLowerCase())
  //         );
  //     }

  //     if (filters.minPrice) {
  //         // @ts-ignore
  //         filtered = filtered.filter((item) => item.price >= filters.minPrice);
  //     }

  //     if (filters.maxPrice) {
  //         // @ts-ignore
  //         filtered = filtered.filter((item) => item.price <= filters.maxPrice);
  //     }

  //     if (filters.propertyType) {
  //         filtered = filtered.filter(
  //             // @ts-ignore
  //             (item) => item.propertyType === filters.propertyType
  //         );
  //     }

  //     setFilteredData(filtered);
  // };

  return (
    <div>
      {/* <AddListing /> */}
      <LandingPageSection />
      <Filter listings={listings} />
      <PropertyCarousel
        id="newest"
        title={"Novinky v ponuke"}
        description={"Naša najnovšia ponuka – vidíte ich ako prví!"}
        sortBy={"newest"}
        properties={listings}
      />
      <PropertyCarousel
        id="houses"
        title={"Rodinné domy"}
        description={"Objavte cenovo dostupné bývanie pre Vašu rodinu."}
        sortBy={"newest"}
        properties={listings}
        filter={{
          propertyType: [
            PropertyType.HOUSE,
            PropertyType.FAMILY_HOUSE,
            PropertyType.COUNTRY_HOUSE,
          ],
        }}
      />
      <PropertyCarousel
        id="cottages"
        title={"Chaty"}
        description={"Oddýchnite si na svojej vlasnej chate."}
        sortBy={"newest"}
        properties={listings}
        filter={{ propertyType: [PropertyType.COTTAGE, PropertyType.CABIN] }}
      />
      <PropertyCarousel
        id="other-interesting-properties"
        title={"Ďalšie naše zaujímavé ponuky"}
        description={"Objavte ďalšie zaujímavé ponuky ako penzióny a budovy."}
        sortBy={"newest"}
        properties={listings}
        filter={{
          notPropertyType: [
            PropertyType.COTTAGE,
            PropertyType.CABIN,
            PropertyType.HOUSE,
            PropertyType.FAMILY_HOUSE,
            PropertyType.COUNTRY_HOUSE,
          ],
        }}
      />

      <div style={{ paddingLeft: "1rem" }} id="all-listings">
        <h2
          className="text-3xl font-bold text-[#9b8b4b]"
          style={{ fontSize: "2rem", color: "#9b8b4b", margin: 0 }}
        >
          Všetky ponuky
        </h2>
        <p
          className="text-gray-600 mt-1"
          style={{ fontWeight: "500", fontSize: "1.2rem", margin: 0 }}
        >
          Tu nájdete všetky naše aktuálne ponuky.
        </p>

        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            padding: "1rem",
          }}
          id="list"
        >
          {[
            ...filteredData.sort(
              // @ts-ignore
              (a, b) => new Date(b?.listedDate) - new Date(a?.listedDate)
            ),
          ].map(
            ({
              title,
              price,
              wholeArea,
              _id,
              photos,
              location,
              propertyType,
            }: any) => (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.2 }}>
                <PropertyCard
                  key={_id}
                  property={{
                    title,
                    price,
                    wholeArea,
                    _id,
                    photos,
                    location,
                    propertyType,
                  }}
                />
              </Grid>
            )
          )}
        </Grid>
      </div>
      <HelpWithPanel />
    </div>
  );
};
